import React from "react";
import { DocumentManager } from "@/components/admin/DocumentManager";

export default function Documents() {
  return (
    <DocumentManager
      title="Documents"
      subtitle="Upload PDFs — manuals, technical bulletins, wiring diagrams. Control what Nick and customers can access."
    />
  );
}
